import api from '@/services/api'

const getCategories = () => {
  return api.get('/categories').then(async ({data}) => {
    return data.collection
  })
}

export default {
  getCategories
}
